import { render } from "./faq.vue?vue&type=template&id=241187b9"
import script from "./faq.vue?vue&type=script&lang=js"
export * from "./faq.vue?vue&type=script&lang=js"

import exportComponent from "E:\\VUE\\Extreme Solutions Jawed Projects\\Extreme Solutions Jawed Projects\\WinWin\\WinWin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__